import {
  Button,
  ListGroup,
  Modal,
  Overlay,
  Text,
} from '@cubeyou-team/hx-react-components';
import React, { FC, useCallback } from 'react';
import { createPortal } from 'react-dom';

import translations from 'src/lang';

import { useDeleteStanleyQueryHistoryItem } from '../../../../../../../../../../../api/hooks';

const tDeleteConfirm =
  translations['en-US'].STANLEY_QUERY.MODAL.HISTORY.DELETE_CONFIRM;

interface StanleyQueryHistoryItemDeleteModalProps {
  isOpen: boolean;
  runId: string;
  title: string;
  onClose: () => void;
}

export const StanleyQueryHistoryItemDeleteModal: FC<
  StanleyQueryHistoryItemDeleteModalProps
> = ({ isOpen, runId, title, onClose }) => {
  const { mutate: deleteItem, isLoading: isDeleting } =
    useDeleteStanleyQueryHistoryItem();

  const handleConfirmDelete = useCallback(
    () => deleteItem({ run_id: runId, title }),
    [deleteItem, runId, title]
  );

  if (typeof document === 'undefined') return null;

  return createPortal(
    <Overlay isOpen={isOpen}>
      <Modal
        data-test-id="stanley-history-delete-confirm-modal"
        closable
        handleClose={onClose}
        title={tDeleteConfirm.TITLE}
        footer={
          <ListGroup
            direction="row"
            items={[
              <Button
                key="confirm-delete"
                size="small"
                variant="danger"
                disabled={isDeleting}
                onClick={handleConfirmDelete}
              >
                {tDeleteConfirm.CONFIRM}
              </Button>,
              <Button
                key="cancel-delete"
                size="small"
                variant="outlined"
                disabled={isDeleting}
                onClick={onClose}
              >
                {tDeleteConfirm.CANCEL}
              </Button>,
            ]}
          />
        }
      >
        <Text size="x_body">{tDeleteConfirm.MESSAGE}</Text>
      </Modal>
    </Overlay>,
    document.body
  );
};
